var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 25L26.6666 25.9117C26.2245 26.3951 25.6251 26.6667 25.0001 26.6667C24.3751 26.6667 23.7757 26.3951 23.3337 25.9117C22.891 25.4293 22.2916 25.1584 21.6668 25.1584C21.042 25.1584 20.4426 25.4293 20 25.9117M12.5 26.6667H13.8955C14.3031 26.6667 14.5069 26.6667 14.6987 26.6206C14.8688 26.5798 15.0314 26.5125 15.1805 26.4211C15.3487 26.318 15.4928 26.1739 15.7811 25.8856L26.25 15.4167C26.9404 14.7263 26.9404 13.607 26.25 12.9167C25.5597 12.2263 24.4404 12.2263 23.75 12.9167L13.2811 23.3856C12.9928 23.6739 12.8487 23.818 12.7456 23.9862C12.6542 24.1353 12.5869 24.2979 12.5461 24.468C12.5 24.6598 12.5 24.8636 12.5 25.2713V26.6667Z",
    stroke: "#1C1B1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e1c3f0a715eec7d1b7f28f2f7c612534.svg";
export { ForwardRef as ReactComponent };